'use client';
import Image from 'next/image';

const speakers = [

  // 2025 speakers
  {
    name: "Chada El Islam Benmahcene",
    designation: "Founder & CEO",
    company: "ENTROGX Ventures",
    imageSrc: "/images/speakers/chada.webp",
    alt: "chada",
  },
  {
    name: "Anna Macmillan",
    designation: "Founder & COO",
    company: "WiiN & Mintlayer",
    imageSrc: "/images/speakers/anna-macmillan.webp",
    alt: "anna-macmillan",
  },
  
  {
    name: "Lianna	Adams",
    designation: "Founder",
    company: "Impactful Artistry",
    imageSrc: "/images/speakers/lianna-adams.webp",
    alt: "lianna-adams",
  },
  {
    name: "Irina Karagyaur",
    designation: "Founder | Creator",
    company: "Creators4Impact | The Business Case for AI & Blockchain",
    imageSrc: "/images/speakers/irina-karagyaur.webp",
    alt: "irina-karagyaur",
  },
  
  {
    name:'Tasneem Taherali',
    designation: "Advisor for Tech Startups and Scale ups, Marketing Director for Women in Tech UAE,",
    company: "Ambassador Product Marketing Alliance UAE",
    imageSrc: "/images/speakers/tasneem-taherali.webp",
    alt: "tasneem-taherali",
  },
  {
    name:'Fatiha Chikh',
    designation: "Co-founder",
    company: "LeLab Plus",
    imageSrc: "/images/speakers/fatiha-chikh.webp",
    alt: "fatiha-chikh",
  },
  
  // 2025 speakers ends
  
  {
    name: "Shyla Khan",
    designation: "CMO",
    company: "Yellow",
    imageSrc: "/images/speakers/shyla-khan.webp",
    alt: "Shyla-Khan-CM",
  },
  {
    name: "Sandy Carter",
    designation: "CBO",
    company: "Unstopable Domains",
    imageSrc: "/images/speakers/sandy.webp",
    alt: "Sandy-Carter",
  },
  {
    name: "Una Wang",
    designation: "Founder & CEO",
    company: "Lingo AI",
    imageSrc: "/images/speakers/una.webp",
    alt: "Una-Wang",
  },
  {
    name: "Wan Wei Soh",
    designation: "CEO & Founder",
    company: "AI Visionary Society",
    imageSrc: "/images/speakers/wanwei.webp",
    alt: "WanWeiSoh",
  },
  {
    name: "Joewin Tan",
    designation: "CEO",
    company: "Quant Consulting Group",
    imageSrc: "/images/speakers/joewin-t.webp",
    alt: "WanWeiSoh",
  },
  {
    name: "Alexandra",
    designation: "Founder & KOL Manager",
    company: "Bybit & Web3mktghack",
    imageSrc: "/images/speakers/alexandra-pic.webp",
    alt: "alexandra",
  },
];

const SpeakerSection = () => {
  return (
    <section
      id="speakers"
      className="w-full px-4 pt-[30px] pb-[40px] flex flex-col items-center justify-center bg-[#ffadc640]"
    >
      <div className="w-full max-w-[1270px]">
        {/* Section Title */}
        <h2 className="text-[24px] sm:text-[30px] lg:text-4xl font-extrabold leading-[28px] sm:leading-[34px] lg:leading-5xl text-center text-text-darkest pb-6 ">
          Past Speakers
        </h2>

        {/* Speaker List Box */}
        <div className="w-full border-[2px] border-[#FA4B7F] rounded-[16px] p-6 sm:p-4">
          {/* Mobile gap-5 and larger screens gap-2 */}
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-5 sm:gap-y-10 place-items-center">
            {speakers.map((speaker, index) => (
              <div key={index} className="flex flex-col items-center">
                {/* Adjusted Image Container for smaller mobile sizes */}
                <div className="w-[120px] h-[120px] sm:w-[200px] sm:h-[200px] relative mb-4">
                  <Image
                    src={speaker.imageSrc}
                    alt={speaker.alt}
                    style={{ objectFit: "cover" }}  // Updated: Move objectFit to style
                    className="rounded-full object-cover"
                    height={230}
                    width={230}
                    sizes="(max-width: 640px) 120px, 200px"
                    unoptimized
                  />
                </div>
                <h3 className="text-[#fa4b7f] font-normal text-[16px] sm:text-[18px] font-HelveticaNeue text-center mb-1">
                  {speaker.name}
                </h3>
                <p className="text-black text-[12px] sm:text-[14px] text-center mb-1">
                  {speaker.designation}
                </p>
                <p className="text-black text-[12px] sm:text-[14px] text-center">
                  {speaker.company}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpeakerSection;
